export enum projectDataType {
    Methods = 0,
    PointId,
    Y,
    X,
    Z,
    Parsed,
    NotParsed,
    NotUsed
}
